import { FunctionComponent, ReactElement, useMemo } from 'react';
import BlueprintIcon from '../../BlueprintIcon';
import Button, { ButtonProps } from '../../Button';
import styles from '../styles.module.scss';
import { PublicOccurrence } from '@cademy-package/sdk-component-types';

type SeeMoreButtonProps = {
    preset?: ButtonProps<any>['preset'];
    shownOccurrences: Array<PublicOccurrence>;
    showAllOccurrences: boolean;
    showOccurrencesClickHandler: () => void;
    occurrencesPerPage?: number;
};

const SeeMoreButton: FunctionComponent<SeeMoreButtonProps> = ({
    preset = 'default',
    shownOccurrences,
    showAllOccurrences,
    showOccurrencesClickHandler,
    occurrencesPerPage = 3,
}) => {
    const occurrencesCount: number = shownOccurrences.length;
    const buttonLabel = useMemo((): string => {
        return showAllOccurrences
            ? 'See Less'
            : `See ${occurrencesCount - occurrencesPerPage} More`;
    }, [occurrencesCount, occurrencesPerPage, showAllOccurrences]);
    const buttonIcon = useMemo((): ReactElement => {
        return (
            <BlueprintIcon
                height={12}
                width={12}
                icon={showAllOccurrences ? 'ArrowUp' : 'ArrowDown'}
            />
        );
    }, [showAllOccurrences]);

    if (occurrencesCount <= occurrencesPerPage) {
        return null;
    }
    return (
        <Button
            className={styles.occurrenceListBtn}
            preset={preset}
            onClick={showOccurrencesClickHandler}
        >
            {buttonLabel} {buttonIcon}
        </Button>
    );
};

export default SeeMoreButton;
